// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetDeepcoinMarketBooks (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketCandles (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketInstruments (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketTickers (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketIndexCandles (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketTrades (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketMarkPriceCandles (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketMarkPrice (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketOpenInterestVolume (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketLongShortRatio (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketTakerVolume (params?: {}): Promise<Dict>;
    publicGetDeepcoinMarketStepMargin (params?: {}): Promise<Dict>;
    publicGetDeepcoinTradeFundingRate (params?: {}): Promise<Dict>;
    publicGetDeepcoinTradeFundRateCurrentFundingRate (params?: {}): Promise<Dict>;
    publicGetDeepcoinTradeFundRateHistory (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountBalances (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountAllBalances (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountBills (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountPositions (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountTradeFee (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountLeverageInfo (params?: {}): Promise<Dict>;
    privateGetDeepcoinAccountPositionsHistory (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeFills (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeOrderByID (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeOrder (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeFinishOrderByID (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeOrdersHistory (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeV2OrdersPending (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeTriggerOrdersPending (params?: {}): Promise<Dict>;
    privateGetDeepcoinTradeTriggerOrdersHistory (params?: {}): Promise<Dict>;
    privateGetDeepcoinCopytradingSupportContracts (params?: {}): Promise<Dict>;
    privateGetDeepcoinCopytradingLeaderPosition (params?: {}): Promise<Dict>;
    privateGetDeepcoinCopytradingEstimateProfit (params?: {}): Promise<Dict>;
    privateGetDeepcoinCopytradingHistoryProfit (params?: {}): Promise<Dict>;
    privateGetDeepcoinCopytradingFollowerRank (params?: {}): Promise<Dict>;
    privateGetDeepcoinInternalTransferSupport (params?: {}): Promise<Dict>;
    privateGetDeepcoinInternalTransferHistoryOrder (params?: {}): Promise<Dict>;
    privateGetDeepcoinRebateConfig (params?: {}): Promise<Dict>;
    privateGetDeepcoinAgentsUsers (params?: {}): Promise<Dict>;
    privateGetDeepcoinAgentsUsersRebateList (params?: {}): Promise<Dict>;
    privateGetDeepcoinAgentsUsersRebates (params?: {}): Promise<Dict>;
    privateGetDeepcoinAssetDepositList (params?: {}): Promise<Dict>;
    privateGetDeepcoinAssetWithdrawList (params?: {}): Promise<Dict>;
    privateGetDeepcoinAssetRechargeChainList (params?: {}): Promise<Dict>;
    privateGetDeepcoinListenkeyAcquire (params?: {}): Promise<Dict>;
    privateGetDeepcoinListenkeyExtend (params?: {}): Promise<Dict>;
    privateGetDeepcoinSubAccountSubAccountApikey (params?: {}): Promise<Dict>;
    privatePostDeepcoinAccountSetLeverage (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeReplaceOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeCancelOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeBatchCancelOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeCancelTriggerOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeSwapCancelAll (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeTriggerOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeAmendTriggerOrder (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeBatchClosePosition (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeReplaceOrderSltp (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeClosePositionByIds (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeIncreasePosition (params?: {}): Promise<Dict>;
    privatePostDeepcoinTradeMergePositions (params?: {}): Promise<Dict>;
    privatePostDeepcoinCopytradingLeaderSettings (params?: {}): Promise<Dict>;
    privatePostDeepcoinCopytradingSetContracts (params?: {}): Promise<Dict>;
    privatePostDeepcoinInternalTransfer (params?: {}): Promise<Dict>;
    privatePostDeepcoinRebateConfig (params?: {}): Promise<Dict>;
    privatePostDeepcoinAssetTransfer (params?: {}): Promise<Dict>;
    privatePostDeepcoinSubAccountCreateSubAccount (params?: {}): Promise<Dict>;
    privatePostDeepcoinSubAccountSubAccountApikey (params?: {}): Promise<Dict>;
    privatePostDeepcoinSubAccountDeleteSubAccountApikey (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
